import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import DataVisualization_001 from './img/DataVisualization_001.png'

export default class DataVisualization extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">数据可视化功能</div>
        <div className="main-window-content">数据可视化功能提供三维地球的展示和添加图层贴图的操作</div>
        <img src={DataVisualization_001} className="main-window-img"></img>
      </div>
    )
  }
}
